import styled from 'styled-components';
import { GlobalToken } from 'antd';

import EPCollapse from '@/comp/EPCollapse';

interface ChartContainerProps {
  $isDynamicControl?: boolean;
  theme: { token: GlobalToken };
}

export const ChartContainer = styled.div<ChartContainerProps>`
  display: flex;
  align-items: center;
  position: relative;
  margin-top: ${({ theme: { token } }) => token.marginXXS}px;

  .charts {
    .highcharts-container {
      min-width: 65vw !important;
      position: unset !important;

      .highcharts-tooltip {
        top: 60px !important;
      }
    }
  }

  .legend {
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    margin-top: ${({ $isDynamicControl, theme: { token } }) =>
      $isDynamicControl ? token.marginXXL : token.marginXL}px;
    margin-left: ${({ theme: { token } }) => token.marginXXL}px;

    .legend-item {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
    }

    .legend-square {
      width: 12px;
      height: 12px;
      margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;

export const StyledCollapse = styled(EPCollapse)<{ theme: { token: GlobalToken } }>`
  .ant-collapse-header {
    background-color: ${({ theme: { token } }) => token.colorBgBase} !important;
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export const DynamicControllerContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  .chart {
    .highcharts-container {
      position: unset !important;

      .highcharts-tooltip {
        top: 10px !important;
      }
    }
  }

  .highcharts-legend-nav-inactive,
  .highcharts-legend-navigation,
  .highcharts-axis-labels,
  .highcharts-axis,
  .highcharts-grid,
  .highcharts-credits {
    display: none;
  }
`;
